import {
  Avatar,
  AvatarGroup,
  Skeleton,
  Tooltip,
  Typography,
} from '@mui/material';

export default function ContractTitleAvatars({ products = [], isLoading }) {
  if (isLoading) {
    return (
      <AvatarGroup
        max={16}
        spacing={-2}
        sx={{ justifyContent: 'flex-end', mt: 1 }}
      >
        {Array.from(new Array(4)).map((_, index) => (
          <Avatar key={index} sx={{ bgcolor: 'transparent', border: 'none' }}>
            <Skeleton variant="circular" width={40} height={40} />
          </Avatar>
        ))}
      </AvatarGroup>
    );
  }

  return (
    <AvatarGroup
      max={16}
      spacing={-2}
      sx={{ justifyContent: 'flex-end', mt: 1 }}
    >
      {products && products.length > 0 ? (
        products.map((product, index) => (
          <Tooltip key={index} title={product.name}>
            <Avatar
              src={product.image}
              sx={{
                '& img': { objectFit: 'contain', padding: '8px' },
                border: 'none !important',
                bgcolor: 'hover.main',
              }}
            >
              <Typography variant="body2" color="primary.main">
                {product.initials}
              </Typography>
            </Avatar>
          </Tooltip>
        ))
      ) : (
        <Typography variant="body2" color="text.secondary">
          Keine Produkte verfügbar
        </Typography>
      )}
    </AvatarGroup>
  );
}
